module.exports = "/_next/static/images/80b03767032f62ad163d48465259854a-fifa-logo.svg";